import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { ParticipantsTableActionDisabled } from 'features/participants/components/Table/Actions/Disabled';
import { ParticipantsTableActionWrapper } from 'features/participants/components/Table/Actions/Wrapper';
import { ParticipantsTableUserInfo } from 'features/participants/config/types';
import { NextSessionSidebar } from 'features/sessions/components/NextSessionForm';

import { ButtonIcon } from 'shared/components/Button';
import { sidebar } from 'shared/components/Sidebar';

type ParticipantsTableNextSessionHintProps = {
  coachingSessionId?: string;
  userInfo: ParticipantsTableUserInfo;
};

export const ParticipantsTableNextSessionHint = ({
  coachingSessionId,
  userInfo,
}: ParticipantsTableNextSessionHintProps) => {
  const handleNextSessionHintClick = () => {
    sidebar.open({
      content: <NextSessionSidebar coachingSessionId={coachingSessionId!} />,
      context: { userInfo },
    });
  };

  return coachingSessionId ? (
    <ButtonIcon
      aria-label="open session hint"
      onClick={handleNextSessionHintClick}
      size="sm"
      variant="ghost"
      data-testid="next-session-hint-button"
    >
      <ParticipantsTableActionWrapper>
        <Icon name={iconNames.clinicalNotes} width="18px" height="18px" />
      </ParticipantsTableActionWrapper>
    </ButtonIcon>
  ) : (
    <ParticipantsTableActionDisabled
      label="User doesn't have sessions yet"
      icon={iconNames.clinicalNotes}
    />
  );
};
